import { IconWithTextListStoryblok } from "@/types/component-types-sb";

import IconWithText from "./IconWithText";

import styles from "./icon-with-text.module.scss";

interface Props {
  blok: IconWithTextListStoryblok;
}

const IconWithTextList = (props: Props) => {
  return (
    <div className={styles.listWrapper}>
      {(props.blok.items || []).map((item) => (
        <IconWithText key={item._uid} blok={item} />
      ))}
    </div>
  );
};

export default IconWithTextList;
